import { ContainerPadding, Text, TextAlignment, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { useCallback, useLayoutEffect, useState } from 'react';
import { LettersInput } from '../../../components/inputs-group/inputs/letters-input';
import { TelefonoInput } from '../../../components/inputs-group/inputs/telefono-input';
import { LegalesSection } from '../../../components/inputs-group/legales-section';
import { InputsGroup } from '../../../components/screen/inputs-group';
import { Section } from '../../../components/screen/section';
import { ThankyouScreen } from '../../../components/screen/thankyou';
import { FIELD_NAME } from '../../../constants/form-constants';
import { useApp } from '../../../contexts/app-context';
import { personEntity } from '../../../entities/person-entity';
import { vehicleEntity } from '../../../entities/vehicle-entity';
import { formService } from '../../../form-service';
import { getBrand, isComerciales } from '../../../helpers/carline-helpers';
import { getFormName, getPageCategory, getParamsForm } from '../../../helpers/form-helpers';
import { getHorariosCallMeOpenNow } from '../../../service/api/get-call-me';
import { setProductData } from '../../../service/product-data';
import { useTrackingManager } from '../../../tracking/use-tracking-manager';
import { CallMeConsentimientosEnvioSection } from './call-me-consentimientos-envio-section';
import { getTextoHorariosCallMe } from './call-me-texto-horarios';

export const CallMeForm = () => {
	const { setAppLoading, setAppThankyouScreen } = useApp();
	const trackingManager = useTrackingManager();
	const [isOpenNow, setIsOpenNow] = useState(false);
	const [horarioTexto, setHorarioTexto] = useState('');

	const getFormData = useCallback(() => {
		const { url } = getParamsForm();

		return {
			brand: isComerciales() ? 'N' : 'V',
			name: personEntity.name,
			prefix: personEntity.phonePrefix,
			cellphone: personEntity.phone,
			lssi: formService.getFieldValue(FIELD_NAME.RGPD_COMUNICACIONES_COMERCIALES) || 'NO INFORMADO',
			tmk: formService.getFieldValue(FIELD_NAME.RGPD_PERFILADO) || 'NO INFORMADO',
			ref: url,
			carlineCode: vehicleEntity.carlineCode,
			ofertaId: vehicleEntity.ofertaId,
		};
	}, []);

	const Form = () =>
		isOpenNow ? (
			<>
				<Section paddingBottom={ContainerPadding.static515}>
					<Text bold appearance={TokenTextAppearance.headline200}>
						Para llamarte, necesitamos tus datos de contacto
					</Text>
					<Text appearance={TokenTextAppearance.copy200}>
						Nos pondremos en contacto contigo {horarioTexto} para darte más información.
					</Text>
					<InputsGroup>
						<LettersInput name={FIELD_NAME.NAME} required />
						<TelefonoInput required />
					</InputsGroup>
				</Section>
				<CallMeConsentimientosEnvioSection formData={getFormData} showComunicacionesComerciales />
				<LegalesSection />
			</>
		) : (
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignContent: 'center',
					gap: '20px',
					padding: '0 15%',
					height: 'calc(100vh - 80px - var(--size-dynamic0270) - var(--size-dynamic0100))',
				}}
			>
				<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center} bold>
					Ahora no podemos atenderte
				</Text>
				<Text appearance={TokenTextAppearance.copy100} textAlign={TextAlignment.center}>
					Lo sentimos, en este momento nuestro servicio de atención telefónica no está disponible. {horarioTexto}
				</Text>
			</div>
		);

	const CustomThankyou = () => {
		return (
			<ThankyouScreen
				title={
					<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center} bold>
						{isComerciales() ? '¡Muchas gracias por tu interés!' : 'Te llamaremos muy pronto'}
					</Text>
				}
				text={
					<Text appearance={TokenTextAppearance.copy100} textAlign={TextAlignment.center}>
						{isComerciales() ? 'En breve te llamaremos desde un número terminado en 904.' : ''}
					</Text>
				}
			/>
		);
	};

	useLayoutEffect(() => {
		setAppLoading(true);
		setAppThankyouScreen(<CustomThankyou />);

		const productDataReady = setProductData();

		getHorariosCallMeOpenNow().then(async (horarios) => {
			setIsOpenNow(!!horarios?.isOpenNow);
			setHorarioTexto(getTextoHorariosCallMe(horarios));
			setAppLoading(false);

			if (horarios?.isOpenNow) {
				await productDataReady;
				trackingManager.trackFormLayerLoad(
					getFormName(),
					getBrand(),
					getPageCategory(),
					formService.getFieldValue(FIELD_NAME.VEHICLE_PRECONFIGURATION),
				);
			}
		});
	}, []);

	return Form();
};
